import { render, staticRenderFns } from "./ExamNotes.vue?vue&type=template&id=4b1fba78&scoped=true&"
import script from "./ExamNotes.vue?vue&type=script&lang=js&"
export * from "./ExamNotes.vue?vue&type=script&lang=js&"
import style0 from "./ExamNotes.vue?vue&type=style&index=0&id=4b1fba78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1fba78",
  null
  
)

export default component.exports